export default "__VITE_ASSET__060fd653__"